package us.laantech.laanmanage.ui.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color

// --- Blue palette ---
private val Blue10  = Color(0xFF001F33)
private val Blue20  = Color(0xFF003A5C)
private val Blue30  = Color(0xFF005685)
private val Blue40  = Color(0xFF0073AE)
private val Blue80  = Color(0xFF8ECFF5)
private val Blue90  = Color(0xFFCAE6FF)
private val Blue95  = Color(0xFFE5F3FF)
private val Blue99  = Color(0xFFF6FBFF)

private val BlueGrey20 = Color(0xFF1B2E3C)
private val BlueGrey30 = Color(0xFF2D4455)
private val BlueGrey80 = Color(0xFFB8CFDE)
private val BlueGrey90 = Color(0xFFD4E4F0)

private val Error10  = Color(0xFF410002)
private val Error40  = Color(0xFFBA1A1A)
private val Error80  = Color(0xFFFFB4AB)
private val Error90  = Color(0xFFFFDAD6)

// --- Light scheme ---
private val LightColorScheme = lightColorScheme(
    primary            = Blue40,
    onPrimary          = Color.White,
    primaryContainer   = Blue90,
    onPrimaryContainer = Blue10,

    secondary            = BlueGrey30,
    onSecondary          = Color.White,
    secondaryContainer   = BlueGrey90,
    onSecondaryContainer = BlueGrey20,

    background    = Blue99,
    onBackground  = Blue10,
    surface       = Blue99,
    onSurface     = Blue10,
    surfaceVariant   = Blue95,
    onSurfaceVariant = BlueGrey20,

    error          = Error40,
    onError        = Color.White,
    errorContainer   = Error90,
    onErrorContainer = Error10,
)

// --- Dark scheme ---
private val DarkColorScheme = darkColorScheme(
    primary            = Blue80,
    onPrimary          = Blue20,
    primaryContainer   = Blue30,
    onPrimaryContainer = Blue90,

    secondary            = BlueGrey80,
    onSecondary          = BlueGrey20,
    secondaryContainer   = BlueGrey30,
    onSecondaryContainer = BlueGrey90,

    background    = Blue10,
    onBackground  = Blue90,
    surface       = Blue10,
    onSurface     = Blue90,
    surfaceVariant   = BlueGrey20,
    onSurfaceVariant = BlueGrey80,

    error          = Error80,
    onError        = Error10,
    errorContainer   = Error40,
    onErrorContainer = Error90,
)

@Composable
fun BackofficeTheme(
    darkTheme: Boolean = false,
    content: @Composable () -> Unit,
) {
    val colorScheme = if (darkTheme) DarkColorScheme else LightColorScheme

    MaterialTheme(
        colorScheme = colorScheme,
        content = content,
    )
}
